import React, { PureComponent } from "react";
import CommonUtil from "../../../utils/CommonUtil";
import TagCloud from "./TagCloud";

class TagCloudContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        enableTooltip: false,
        rotations: 0,
        size: [400, 400],
        scale: [10, 20],
        fontSizes: [18, 36],
        fontFamily: "Arial",
        padding: 5
      }
    };
  }

  shouldComponentUpdate(nextProps) {
    return !CommonUtil.jsonEquals(this.props.data, nextProps.data);
  }

  render() {
    return (
      <TagCloud
        words={this.props.data}
        options={this.state.options}
        callbacks={this.props.callbacks}
      />
    );
  }
}
export default TagCloudContainer;
